import { Box } from '@mui/material';
import { ControlledDatePicker } from 'components/shared/ControlledFields';
import { t } from 'i18next';
import { Control } from 'react-hook-form';

type StartAndEndDateProps = {
  control: Control<any>;
  defaultValues: {
    startDate: string;
    endDate: string;
  };
};

const StartAndEndDate = ({ control, defaultValues }: StartAndEndDateProps) => {
  return (
    <>
      <Box marginTop={1} marginRight={1}>
        <ControlledDatePicker
          variant="outlined"
          name="startDate"
          label={t('startDate')}
          control={control}
          defaultValue={defaultValues.startDate}
        />
      </Box>
      <Box marginTop={1}>
        <ControlledDatePicker
          variant="outlined"
          name="endDate"
          label={t('endDate')}
          control={control}
        />
      </Box>
    </>
  );
};

export default StartAndEndDate;
